module.exports = __webpack_public_path__ + "media/images/webcam-fda3a1970b3469bd4ecb4f691727ef931a39237d9a4d502b30be8c4f8a4a6cf4.png";